import { spacing } from '@tq/ui-components/dist/components/mobile-options-accordion/styles/theme/spacing';

export const CHECKBOX_SIZE = spacing(8);
export const CARD_LEFT_PADDING_SIZE = spacing(9);
export const CARD_RIGHT_PADDING_SIZE = spacing(8);
export const ROW_TEMPLATE_COLUMNS_DESKTOP = '1fr 1fr 1fr';
